import { render, staticRenderFns } from "./menu-title.vue?vue&type=template&id=55f76282"
import script from "./menu-title.vue?vue&type=script&lang=js"
export * from "./menu-title.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports